
import api from './api';

const endpoint = '/api/receitas';

const ReceitasService = {
  getAll: async () => {
    const response = await api.get(endpoint);
    return response.data;
  },

  getAtivas: async () => {
    const response = await api.get(`${endpoint}/ativas`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`${endpoint}/${id}`);
    return response.data;
  },

  /*
  create: async (descricao, idOrigem, pago) => {
    return await api.post('/api/receitas', null, {
      params: {
        descricao,
        idOrigem, 
        pago
      }
    });
  },*/
  create: async (payload) => {
    const response = await api.post(endpoint, payload);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`${endpoint}/${id}`, data);
    return response.data;
  },

  inativar: async (id) => {
    const response = await api.patch(`${endpoint}/${id}/inativar`);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`${endpoint}/${id}`);
    return response.data;
  },
};

export default ReceitasService;